<script>
'use strict'

export default {
  hasRole (user, ...roles) {
    if (!user || !user.role) {
      return false
    }

    for (let roleName of roles) {
      if (user.role === roleName) {
        return true
      }
    }

    return false
  }
}
</script>



// WEBPACK FOOTER //
// acl.vue?601cffc4